module.exports = __webpack_public_path__ + "static/media/maxParties_75_100.713eee35.png";